import React from 'react'

const RawHtml = ({ markup, tag = 'div' }) => {
  const Tag = tag
  return <Tag dangerouslySetInnerHTML={{ __html: markup }} />
}

export default RawHtml
